<template>
  <section class="rmr-page-hero">
    <div class="rmr-page-hero__inner" :style="innerStyle">
      <div class="rmr-page-hero__brand">
        <div class="rmr-page-hero__icon">
          <v-icon color="white" :size="iconSize">{{ icon }}</v-icon>
        </div>
        <div class="rmr-page-hero__copy">
          <h1 class="rmr-page-hero__title">
            {{ title }}
            <span v-if="titleAccent">{{ titleAccent }}</span>
          </h1>
          <slot name="subtitle">
            <p v-if="subtitle" class="rmr-page-hero__subtitle">
              {{ subtitle }}
            </p>
          </slot>
        </div>
      </div>

      <div v-if="$slots.actions" class="rmr-page-hero__actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RmrPageHero",
  props: {
    title: {
      type: String,
      required: true,
    },
    titleAccent: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 22,
    },
    maxWidth: {
      type: String,
      default: "1440px",
    },
  },
  computed: {
    innerStyle() {
      return {
        maxWidth: this.maxWidth,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-page-hero {
  background: linear-gradient(135deg, $rmr-indigo-dark 0%, $rmr-indigo-accent 40%, $rmr-indigo 100%);
  padding: 28px 32px 20px;
  margin: -12px -12px 0;
}

.rmr-page-hero__inner {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.rmr-page-hero__brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.rmr-page-hero__icon {
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  border-radius: $rmr-radius-lg;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.rmr-page-hero__copy {
  min-width: 0;
}

.rmr-page-hero .rmr-page-hero__title {
  font-size: 22px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.8) !important;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.3px;

  span {
    font-weight: 700;
    color: $rmr-surface-0 !important;
  }
}

.rmr-page-hero__subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 4px 0 0;
  font-weight: 500;
}

.rmr-page-hero__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 12px;
}

@media (max-width: 960px) {
  .rmr-page-hero {
    padding: 20px 16px;
  }

  .rmr-page-hero__inner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
